import Map, { FullscreenControl, GeolocateControl, Layer, Marker, NavigationControl, Source } from 'react-map-gl';
import data, { mapbox_token, urlapi } from '../../../lib/backend/data';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Col, Modal, Pagination, Popover, Row, Spinner } from 'react-bootstrap';
import SelectorZona from '../../RadioOperacion/selector_zona';
import bbox from '@turf/bbox';
import { colorByTypeNotification, obtenerCentroMapaPorPais, stringByTipoDetection, stringByTipoNotification } from '../../../lib/helpers/data/internationa';
import { fechaUTCATexto } from '../../../lib/helpers/helpers';
import { calcularPuntoCentral } from '../../../lib/helpers/maps/geocercas';
import ModalAlertasZona from './modal_alerta';
import ListadoAlertas from '../../GeoAlertas/listado';
import { cerrarSesion } from '../../../redux/actions/session';
import Skeleton from 'react-loading-skeleton';
import { toast } from 'react-toastify';
import { AiFillAlert, AiFillEye, AiOutlineClose, AiOutlineExpand, AiOutlineSearch } from 'react-icons/ai';
import { tituloPorTipoNotificacion } from '../../../lib/helpers/alertas';
import { RxAvatar } from 'react-icons/rx';
import SelectorRangoFechas from '../../../subComponents/general/selector_rango_fechas';
import PantallaCargando from './pantalla_cargando';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { obtenerRangos } from '../../../lib/helpers/opcionesfecha';
import LoadingNotifications from '../../../subComponents/general/loadingAnimations/loadingPushNotifications';
import { BsBoxArrowInUpRight } from 'react-icons/bs';

const tipos_vista = [
  {
    label: "Ver por alertas",
    tipo: "alertas"
  },
  {
    label: "Ver por geocercas",
    tipo: "zonas"
  }
]
const MapaZonasAlertasMantenedor = (props) => {
    const {
        height,
        resize,
        redzone,
        tipo_operacion_default,
        hideControls
    } = props
    const initialDate = {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
  }
    const [ zonasBD, setZonasBD ] = useState([])
    const [ pagina, setPagina ] = useState(1)
    const [ tipoVista, setTipoVista ] = useState("alertas")
    const [ loadingMaster, setLoadingMaster ] = useState(true)
    const [ focusOnMap, setFocusOnMap ] = useState(false)
    const [ alertas, setAlertas ] = useState([])
    const [ alertaSeleccionada, setAlertaSeleccionada ] = useState(false)
    const [ geocercas, setGeoCercas ] = useState([])
    const pais = useSelector(state => state.pais)
    const idioma = useSelector(state => state.idioma)
    const [ total, setTotal ] = useState(0)
    const [ coleccion, setColeccion ] = useState({
      type: 'FeatureCollection',
      features: []
    })
    const [selectionRange, setSelectionRange] = useState(initialDate)
    const sesion = useSelector(state => state.miusuario)
    const defaultViewState = obtenerCentroMapaPorPais(pais)
    const [ filtroTipo, setFiltroTipo ] = useState('')
    const [viewState, setViewState] = useState(defaultViewState);
    const [ zoomInit, setZoomInit ] = useState(false) 
    const [ showFilters, setShowFilters ] = useState(false) 
    const dispatch = useDispatch()
    const mapRef = useRef()
    const tipo_operacion = tipo_operacion_default ? tipo_operacion_default : "operacion"
    const [ condicion_busqueda, setCondicionBusqueda ] = useState({})
    const [ showModalAlertas, setShowModalAlertas ] = useState(false)
    const [ condicionAlertas, setCondicionAlertas ] = useState(false)

    const ajustarMapaAGeocercas = (datos) => {
      const instancia_geocercas = JSON.parse( JSON.stringify( datos ))
      if(instancia_geocercas.length < 1) return false
          const coordinates = instancia_geocercas.reduce((acc, geofence) => {
            const geofenceCoords = geofence.geometry.coordinates;
            if (geofenceCoords.length === 1) {
              // Polygon
              acc.push(geofenceCoords[0]);
            } else {
              // MultiPolygon
              geofenceCoords.forEach((coords) => {
                if(coords.length < 1) return false
                acc.push(coords[0]);
              });
            }
            return acc;
          }, []);
    
          const combinedFeatures = {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                properties: {},
                geometry: {
                  type: 'Polygon',
                  coordinates,
                },
              },
            ],
          };
  
            const bounds = bbox(combinedFeatures);
            const newViewport = {
              ...viewState,
              latitude: (bounds[1] + bounds[3]) / 2,
              longitude: (bounds[0] + bounds[2]) / 2
            };
      
            const options = {
              padding: 30 // Ajusta el valor de padding según tus necesidades
            };
      
            setViewState(newViewport);
            mapRef.current?.fitBounds(bounds, options);
    }

    useEffect(() => {
      if(mapRef) if(mapRef.current) mapRef.current.resize()
      obtenerGeocercaBD(1, false, true)
    }, [ resize ])

    const refrescarDatos = () => {
      const cond = {}
      if(filtroTipo) cond.tipo_notificacion = filtroTipo

      const { desde, hasta } = obtenerRangos(selectionRange.startDate, selectionRange.endDate)
      cond.createdAt = { $gte: desde, $lte: hasta }
      setCondicionBusqueda(cond)
      obtenerGeocercaBD(1, cond, false)
    }

    const handleChangeTipoVista = (e) => {
      const i = tipos_vista.findIndex(t => t.label === e)
      setTipoVista(tipos_vista[i].tipo)
    }

    const iconoPorTipoAlerta = (type, size) => {
      const fontSize = size ? size : 15
      switch (type) {
        case "info":
          return <AiFillAlert style={{ color: "blue", fontSize }} />
        case "warning":
          return <AiFillAlert style={{ color: "orange", fontSize }} />
        case "danger":
          return <AiFillAlert style={{ color: "orange", fontSize }} />
        default:
          return <AiFillAlert style={{ color: "red", fontSize }} />
      }
    }

    const centrarMapa = (centro, max_zoom) => {
      const nuevo_zoom = defaultViewState.zoom + (max_zoom ? max_zoom : 3)
      setFocusOnMap(true)
      mapRef.current?.flyTo({center: [centro.longitude, centro.latitude], zoom: nuevo_zoom, duration: 2000});
      setTimeout(() => {
        setViewState({ ...viewState, longitude: centro.longitude, latitude: centro.latitude, zoom: nuevo_zoom });
      }, 2010);
    }

    const seleccionarPunto = (alerta) => {
      setAlertaSeleccionada(alerta._id)
      return centrarMapa({ longitude: alerta.location.coordinates[0], latitude: alerta.location.coordinates[1] }, 5)
    }

    const visualizacionAlertas  = () => {

      return <div className='mb-1'>
          <div className='mb-3'>
          <h5 className='mb-0 mt-0' level={5}>{total} alertas en total</h5>
          <h5 className='mb-0 mt-0' level={4}>Se visualizan {alertas.length} alertas</h5>
          {resetMapView()}
          </div>
          {paginacion(data.pagina, total)}
        {
          alertas.map((alerta,pos) => {
            return <div key={alerta._id} >
              <Card className='p-2 mb-2'>
              <span style={{ fontSize: 9 }} className='mb-0'>{fechaUTCATexto(alerta.createdAt)}</span>
              <p className="text-white mb-1"><b style={{ width: "fit-content", fontSize: 10, padding: "4px 15px", background: "gray" }}>TIPO DE ALERTA</b><b style={{ width: "fit-content", fontSize: 10, padding: "4px 15px", backgroundColor: colorByTypeNotification(alerta.tipo_notificacion) }}><AiFillAlert /> {stringByTipoNotification(alerta.tipo_notificacion)}</b></p>
              <p style={{ fontSize: 12, fontWeight: "bold" }} className='mt-0 mb-1'>{alerta.mensaje}</p>
              <Button size="sm" disabled={alertaSeleccionada === alerta._id} variant='light' style={{ width: "100%", fontSize:10 }} onClick={() => seleccionarPunto(alerta)} ><AiFillEye size={15} /> VER EN MAPA</Button>
              </Card>
            </div>
          })
        }
      </div>
    }

    const resetMapView = () => {
      if(!focusOnMap) return false
      return <div className='mt-2 mb-2'>
        <Button size="sm" type="primary" onClick={() => {
          setAlertaSeleccionada(false)
          setFocusOnMap(false)
          ajustarMapaAGeocercas(coleccion.features)
      }}><AiOutlineExpand /> VOLVER A MAPA COMPLETO</Button>
      </div>
    }

    const abrirAlertasCondicionadas = (cond) => {
      setCondicionAlertas(cond)
      return setTimeout(() => {
        setShowModalAlertas(true)
      }, 200);
    }

    const handleCloseModal = () => {
      setShowModalAlertas(false)
    }

    const handleCancel = () => {
      setShowModalAlertas(false)
    }

    const modalAlertas = () => {
      return <Modal width={"80%"} open={showModalAlertas} footer={[]} onCancel={() => handleCloseModal()}>
        {JSON.stringify()}
          <ListadoAlertas condicion_default={condicionAlertas} />
    </Modal>
    }

    const visualizacionZonas = () => {
      return <div className='mb-4'>
        <Card className='mb-3' style={{ marginTop: 10, }}>
          <h5 className='mb-0 mt-0' level={5}><AiFillAlert style={{ color: "red" }} /> {geocercas.length} Zonas con alertas</h5>
          {resetMapView()}
          </Card>
        {
          geocercas.map((geo,pos) => {
            let titulo_zona = 'Sin información de la zona'
            if(geo.zona){
              if(typeof geo.zona === "object"){
                if(geo.zona.titulo) titulo_zona = geo.zona.titulo
              }
            }
            let coordenadas = []
            for( const arreglo of geo.geometry.coordinates ){
                if(Array.isArray(arreglo) !== false){
                  for( const item of arreglo ){
                    coordenadas.push({ latitude: item[1], longitude: item[0] })
                  }
                }
            }
            const centro = calcularPuntoCentral(coordenadas)
            return <div key={geo._id} className='mb-0' >
              <span style={{ fontSize: 9 }} className='mb-0'>Zona</span>
                <p style={{ fontSize: 17, fontWeight: "bold", marginBottom: 10, lineHeight: "10px" }} className='mt-0'>{geo._id ? false : <Spinner animation='border' style={{ marginRight: 5 }}/> } {titulo_zona.toString().toUpperCase()}</p>
                <Button size="small"  style={{ width: "100%" }} onClick={() => centrarMapa(centro)} ><AiFillEye size={15} /> VER EN MAPA</Button>
                <ModalAlertasZona condicion_default={{ id_zona: geo.id_zona }} />
                {modalAlertas()}
                { geocercas.length === (pos+1) ? false : <hr className='mb-0' />  }
                </div>
          })
        }
      </div>
    }

    const visualizarDatos = () => {
      if(tipoVista === "alertas") return visualizacionAlertas()
      if(tipoVista === "zonas") return visualizacionZonas()
    }

    const mostrarListado = () => {
      if(loadingMaster) return <LoadingNotifications />
      if(geocercas.length < 1 ) return <div className='mb-3' ><h5 className='mb-0 mt-0' level={4}>Sin datos</h5></div>

      const seleccionado = tipos_vista[tipos_vista.findIndex(t => t.tipo === tipoVista)].label
      return <div>
        {visualizarDatos()}
      </div>
    }

    const obtenerGeocercaBD = async (page, query, centrar) => {
        setLoadingMaster(true)
        const condicion = query ? query : condicion_busqueda
      return fetch(`${urlapi}/geodata/alertas/geo/map/list`, {
        method: 'POST',
        body: JSON.stringify({ 
          condicion,
          pagina: page
         }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer: ${sesion.tokenSession}`,
          'country': pais,
          'lang': idioma
        },
      })
        .then((res) => {
          if (res.status === 401) return dispatch(cerrarSesion());
          return res.json();
        })
        .then(async (res) => {
          if (!res) {
              toast.error("Sin datos obtenidos")
          } else if (res.errorMessage) {
              toast.error(res.errorMessage)
          } else if(Array.isArray(res.datos) !== false){

            const extraer_geocercas = res.geocercas.map(ge => {
              ge.geometry = ge.region
              return ge
            })

            setAlertas(res.datos)
            setGeoCercas(extraer_geocercas)
            setTotal(res.total)
            setColeccion((prevCollection) => ({
              ...prevCollection,
              features: [...[], ...extraer_geocercas],
            }))
            if(centrar === true){
              ajustarMapaAGeocercas(extraer_geocercas)
            }
          }

          return setLoadingMaster(false)
        })
        .catch((error) => {
          toast.error("Error al consultar la información, intente nuevamente")
          return setLoadingMaster(false)
        })
    }

    const eliminarGeocerca = async (id) => {
      const instancia_geocercas = JSON.parse( JSON.stringify( geocercas ))
      const i = instancia_geocercas.findIndex(g => g._id === id)
      if(i > -1){
        geocercas[i].deleting = true
      } else {
        return false
      }
      return fetch(`${urlapi}/geodata/zonas/asociar?id=${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer: ${sesion.tokenSession}`,
          'country': pais,
          'lang': idioma
        },
      })
        .then((res) => {
          if (res.status === 401) return dispatch(cerrarSesion());
          return res.json();
        })
        .then(async (res) => {
          if (!res) {
              toast.error("Sin datos obtenidos")
          } else if (res.errorMessage) {
              toast.error(res.errorMessage)
          } else if(res._id){
            toast.success("Eliminado exitosamente")
              instancia_geocercas.splice(i,1)
              setColeccion((prevCollection) => ({
                ...prevCollection,
                features: [...[], ...instancia_geocercas],
              }))
              setGeoCercas([...[], ...instancia_geocercas])
          }
          return false
        })
        .catch((error) => {
          toast.error("Error al consultar la información, intente nuevamente")
          return false
        })
    }

    const guardarGeocercaBD = async (id, tipo, nuevo_arreglo) => {
      return fetch(`${urlapi}/geodata/zonas/asociar?id=${id}&tipo=${tipo}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer: ${sesion.tokenSession}`,
          'country': pais,
          'lang': idioma
        },
      })
        .then((res) => {
          if (res.status === 401) return dispatch(cerrarSesion());
          return res.json();
        })
        .then(async (res) => {
          if (!res) {
              toast.error("Sin datos obtenidos")
          } else if (res.errorMessage) {
              toast.error(res.errorMessage)
          } else if(res._id){
            toast.success("Guardado exitosamente")
            const i = nuevo_arreglo.findIndex(geo => geo.id_geocerca === id)
            if(i > -1 ){
              nuevo_arreglo[i]._id = res._id
              setGeoCercas([...[], ...nuevo_arreglo])
            }
          }
          return false
        })
        .catch((error) => {
          toast.error("Error al consultar la información, intente nuevamente")
          return false
        })
    }

    const onAgregarZona = (data) => {
      const buscar = geocercas.findIndex(geo => geo.id_geocerca === data._id)
      if(buscar > -1) return toast.error("Esta geocerca ya fue agregada")
        const nueva = {
            id_geocerca: data._id,
            titulo: data.titulo,
            type: "Feature",
            properties: data.properties,
            geometry: {
              type: data.region.type,
              coordinates: data.region.coordinates
            }
          }
          const nuevo_arreglo = [...geocercas, ...[nueva]]
          console.log({nuevo_arreglo})
          setGeoCercas(nuevo_arreglo)
          coleccion.features = nuevo_arreglo
          setColeccion((prevCollection) => ({
            ...prevCollection,
            features: [...prevCollection.features, nueva],
          }))
          guardarGeocercaBD(data._id, tipo_operacion, nuevo_arreglo)
    }

    const handleChangePagina = (e) => {
        setPagina(e)
        obtenerGeocercaBD(e, condicion_busqueda)
    }

    const paginar = (page,ignorar) => {
      if(ignorar) return false
      setPagina(page)
      obtenerGeocercaBD(page)
  }
  
    const paginacion = (ciclo, total) => {
      const cantidad = Math.ceil(total / ciclo)
      return <div>
          <Pagination size='sm'>
              {
                  Array.from(Array(cantidad).keys()).map(number => {
                      const active = pagina === (number+1) ? true : false
                      return <Pagination.Item key={number+1} active={active} onClick={()=>paginar(number+1,active)} >{number+1}</Pagination.Item>
                  })
              }
          </Pagination>
      </div>
    }


    const mostrarAlertas = (marker) => {
      if(!marker) return false
      if(!marker.alertas) return false
      if(Array.isArray(marker.alertas) !== true) return false
      if(marker.alertas.length < 1) return <h4 className='mb-0 mt-0'>Sin datos</h4>
      return <div>
        {
          marker.alertas.map((alerta,i) => {
            return <div key={`alert-${i}`}>
              <span style={{ fontSize: 9 }}>{fechaUTCATexto(alerta.createdAt)}</span>
              <p >{alerta.mensaje}</p>
            </div>
          })
        }
      </div>
    }

    const mostrarFotoPerfil = (driver) => {

      const default_object = <div className='p-1' style={{ display: "inline-block", backgroundColor: "white", verticalAlign: "middle", borderRadius: "50%" }}><RxAvatar size={30} /></div>
      if(!driver.image_profile) return default_object
    
      return <div className='p-1' style={{ display: "inline-block", width: 30, height: 30, borderRadius: "50%", verticalAlign: "middle", backgroundPosition: "center center", backgroundImage: `url(${driver.image_profile})`, backgroundSize: 'cover' }}></div>
    }

    const mostrarGoogleLink = (marker) => {
      if(!marker.location) return false
      if(typeof marker.location !== "object") return false
      if(!marker.location.coordinates) return false
      if(Array.isArray(marker.location.coordinates) !== true) return false
      if(marker.location.coordinates.length < 2) return false
      return <a href={`https://www.google.com/maps?q=${marker.location.coordinates[1]},${marker.location.coordinates[0]}`} target='_blank'><BsBoxArrowInUpRight /> VER EN GOOGLE</a>
    }

    const mostrarTarget = (marker) => {
      if(!marker) return false
      if(typeof marker !== "object") return false
      return <div>
              {mostrarFotoPerfil(marker)}
              <div style={{ display: "inline-block", verticalAlign: "middle" }}>
              <p className='mb-0' style={{ fontSize: 14 }}>{marker.nombres ? marker.nombres : ""} {marker.apellidos ? marker.apellidos : ""}</p>
              <p className='mb-0' style={{ fontSize: 14, textTransform: "uppercase" }}>{marker.modelo ? marker.modelo : ""} {marker.patente ? marker.patente : ""}</p>
              </div>

      </div>
    }

    const mostrarPuntosAlertas = () => {
      if(!coleccion) return false
      if(typeof coleccion !== "object") return false
      if(!coleccion.features) return false
      if(Array.isArray(coleccion.features) !== true) return false

      return alertas.map(marker => {
        try {

          if(alertaSeleccionada) if(marker._id !== alertaSeleccionada) return false
          
            let longitude = 0
            let latitude = 0

            if(marker.location){
              if(typeof marker.location === "object"){
                if(marker.location.coordinates){
                  if(Array.isArray(marker.location.coordinates) !== false){
                    if(marker.location.coordinates.length > 1){
                      latitude = marker.location.coordinates[1]
                      longitude = marker.location.coordinates[0]
                    }
                  }
                }
              }
            }

            const default_maker = <Marker
            key={`${marker._id}-alert`}
            longitude={longitude}
            latitude={latitude}
            ><div onClick={() => seleccionarPunto(marker)}>{iconoPorTipoAlerta(marker.tipo_notificacion, 35)}</div>
          </Marker>

            if(!latitude || !longitude) return false
            if(!alertaSeleccionada) return default_maker
            if(alertaSeleccionada) if(marker._id !== alertaSeleccionada) return false

            let titulo_geocerca = ''
            const i = geocercas.findIndex(geo => geo._id === marker.id_geocerca)
            if(i > -1) titulo_geocerca = geocercas[i].titulo

              return <Marker
                      key={`${marker._id}-alert`}
                      longitude={longitude}
                      latitude={latitude}
                  >
                <Card className='p-2'>
                  <Row>
                    <Col>
                      {iconoPorTipoAlerta(marker.tipo_notificacion)}
                      {stringByTipoNotification(marker.tipo_notificacion)}
                    </Col>
                    <Col className='text-right'><p style={{ fontSize: 12 }} className='mb-0' onClick={() => setAlertaSeleccionada(false)}><AiOutlineClose/> CERRAR</p></Col>
                  </Row>
                      <p style={{ fontSize: 10 }} className='mb-0 '>{fechaUTCATexto(marker.createdAt)}</p>
                      <p className="text-white mb-1"><b style={{ width: "fit-content", fontSize: 10, padding: "4px 15px", background: "gray" }}>TIPO DE DETECCIÓN</b><b style={{ width: "fit-content", fontSize: 10, padding: "4px 15px", backgroundColor: "black" }}>{stringByTipoDetection(marker.tipo_deteccion)}</b></p>
                      {titulo_geocerca}
                      {mostrarTarget(marker.target)}
                      {mostrarGoogleLink(marker)}
                </Card>
              </Marker>
          
        } catch (error) {
          console.log(error)
          return false
        }
      })
    }

    const mostrarPuntosGeoZonas = () => {
      return coleccion.features.map(marker => {
        try {
          let coordenadas = []
          for( const arreglo of marker.geometry.coordinates ){
              if(Array.isArray(arreglo) !== false){
                for( const item of arreglo ){
                  coordenadas.push({ latitude: item[1], longitude: item[0] })
                }
              }
          }
          const centro = calcularPuntoCentral(coordenadas)
          let titulo_zona = 'Zona sin información'

          if(alertaSeleccionada) return false

          if(marker.zona){
            if(typeof marker.zona === "object") if(marker.zona.titulo) titulo_zona = `Zona ${marker.zona.titulo}`
          }
          if(centro){
            const content = (
              <div>{mostrarAlertas(marker)}</div>
              )
              return <Marker
                      key={`${marker._id}-alert`}
                      longitude={centro.longitude}
                      latitude={centro.latitude}
                  >
              <div style={{ padding: 30, textAlign: "center" }}>
                <div style={{ height: 20 }}></div>
                <p style={{ backgroundColor: "#00000069", borderRadius: 5, fontSize: 13, padding: "0px 10px", color: "white" }}>{titulo_zona}</p>
              </div>
              </Marker>
          }
        } catch (error) {
          console.log(error)
          return false
        }
      })
    }

    const handleChangeTipo = (e) => {
      return setFiltroTipo(e.target.value)
    }

    const cambiarRangoFecha = (item) => {
      setSelectionRange(item.selection)
  }

    const mostrarFiltros = () => {
      if(!showFilters) return <div>
          <Card className='p-1 mb-2 shadow'><p className='mb-0 hover' onClick={() => setShowFilters(!showFilters)}><BiChevronDown size={20} /> Mostrar filtros</p></Card>
      </div>

      return <div>
        <Card className='p-1 shadow mb-2' >
          <p className='hover mb-0' onClick={() => setShowFilters(!showFilters)}><BiChevronUp size={20} /> Ocultar filtros</p>
        <div className='mb-2'><SelectorRangoFechas typeView="small" onChange={(item) => cambiarRangoFecha(item)}  /></div>
            <div className='mb-2'>
              <label className='form-control-label d-block'>Filtrar por tipo</label>
              <select className='form-control' value={filtroTipo} onChange={handleChangeTipo}>
                <option value="">Todos</option>
                <option value="info">Información</option>
                <option value="warning">Precaución</option>
                <option value="danger">Problema</option>
              </select>
            </div>
            <div className='mb-2'><Button size='sm' variant='light' className='w-100' onClick={() => refrescarDatos()} ><AiOutlineSearch /> BUSCAR</Button></div>
        </Card>
      </div>
    }

    return <div style={{ height: "100%" }}>
        <Row style={{ height: "100%" }} >
          <Col md={3} style={{ height: "100%", overflowY: "scroll", overflowX: "hidden" }}>
            <Card className='p-2' style={{ height: "100%" }}>
            <h5 className="mb-2"><AiFillAlert /> Mapa de alertas</h5>
            {mostrarFiltros()}
            {mostrarListado()}
            </Card>
          </Col>
          <Col md={9} style={{ height: "100%" }}>
          <Map
            ref={mapRef}
            {...viewState}
            onMove={evt => setViewState(evt.viewState)}
            style={{width: "100%", height: "100%"}}
            scrollZoom={false}
            mapStyle="mapbox://styles/mapbox/light-v9"
            mapboxAccessToken={mapbox_token}
          >
            <GeolocateControl position="top-left" />
            <FullscreenControl position="top-left" />
            <NavigationControl position="top-left" />
                <Source
                        id={"geocerca._id"}
                        type="geojson"
                        data={coleccion}
                        >
                            {mostrarPuntosAlertas()}
                            {mostrarPuntosGeoZonas()}
                            <Layer
                                id="geocercas-layer"
                                type="line"
                                paint={{
                                    'line-width': 4,
                                    'line-color': '#0080ef'
                                  }}                      
                                />
                        </Source>
                            
                  
          </Map>
          </Col>
        </Row>

        
        
  </div>
}

export default MapaZonasAlertasMantenedor